PJQ.views.budget.CostTypeSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'cost-type-settings')
    },
    events: {
        'click .btn-add-cost-type': 'addClicked',
        'click .btn-edit-cost-type': 'editClicked',
        'click .btn-delete-cost-type': 'deleteClicked',
        'click .btn-delete-all': 'deleteAll',
        'click .btn-push-erp': 'pushERP',
        'click .btn-pull-erp': 'pullERP',
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        if (this.options.project != null) {
            this.budget = await this.options.project.fetchBudget();
            this.costTypes = await this.options.project.fetchCostTypes();

            if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
                await this.options.project.fetchERPObject();
            }
        } else {
            this.costTypes = await PJQ.app.session.fetchCostTypes();
        }

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            project: this.options.project,
            costTypes: this.costTypes,
            isFetched: this.isFetched,
            erpIntegration: this.erpIntegration,
            budget: this.budget
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.stopListening(this.costTypes);
        this.listenTo(this.costTypes, 'update', () => {
            this.renderERP();
        });
        this.renderERP();

        this.renderCostTypeTable();
    },
    renderCostTypeTable: function () {
        if (this.dataTable && this.dataTable.dataTable) {
            this.dataTable.dataTable.destroy();
            this.dataTable = null;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".cost-types-table"),
            data: this.costTypes.models,
            order: [1, 'asc'],
            onRowDoubleClick: _.bind(function (row) {
                this.editCostType(row.data());
            }, this),
            rowId: 'cid',
            paging: false,
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: (row) => {
                            this.editCostType(row.data());
                        }
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: (row) => {
                            if (this.budget) {
                                return null == this.budget.lineItems.findWhere({costTypeId: row.data().id});
                            } else {
                                return true;
                            }
                        },
                        onClick: (row) => {
                            this.deleteCostType(row.data());
                        }
                    }
                ]
            },
            columns: [
                {
                    "title": "",
                    "data": "attributes.externalObject",
                    "width": "5%",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": (data, type, row) => {
                        if (data) {
                            return '<i class="fas fa-link-simple fs-14 text-success" title="Synced to ERP"></i>';
                        }
                        return '';
                    }
                },
                {
                    "data": "attributes.code",
                    "title": "Code",
                    "width": "15%"
                },
                {
                    "data": "attributes.name",
                    "title": "Name"
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "className": "p-2",
                    "width": "80px",
                    "render": (data, type, model) => {
                        let canDelete = null == this.budget || null == this.budget.lineItems.findWhere({costTypeId: model.id}),
                            res = '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info btn-edit-cost-type ml-1 fs-14"><span class="fal fa-pencil"></span></button>';
                        if (canDelete) {
                            res += '<button type="button" class="btn btn-danger btn-delete-cost-type ml-1 fs-14"><span class="fal fa-trash"></span></button>';
                        } else {
                            res += '<button type="button" disabled class="btn btn-danger ml-1 fs-14" title="This cost code has associated budget line items"><span class="fal fa-trash"></span></button>';
                        }
                        return res + '</div>';
                    }
                }
            ],
            language: {
                zeroRecords: 'Click "Add Cost Type" to create a new Cost Type'
            }
        });
    },
    renderERP: function () {
        if (this.erpIntegration == null) {
            return;
        }

        let hasStaleCostTypes = null != _.find(this.costTypes.models, function (costType) {
                return costType.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.PENDING
                    || costType.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.STALE;
            }),
            pushSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COST_TYPES),
            status = pushSupported && hasStaleCostTypes ? PJQ.constants.integrations.erp.syncStatuses.STALE : PJQ.constants.integrations.erp.syncStatuses.SYNCED,
            pullSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COST_TYPES);
        this.erpButtons = PJQ.helpers.erp.renderERPButtons(this.$('.erp-sync'), {
            pushSupported: pushSupported,
            canPush: hasStaleCostTypes,
            disablePushReason: !hasStaleCostTypes ? 'All cost type changes have been pushed to ERP' : '',
            pullSupported: pullSupported,
            status: status
        });

        let badge = PJQ.helpers.erp.getERPBadge(status);
        this.$('.erp-badge').html('<span class="ml-2">' + badge + '</span>');
    },
    pushERP: function () {
        if (this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COST_TYPES)) {
            this.erpButtons?.pushing(true);
            this.erpIntegration.pushCostTypes((res, err) => {
                this.erpButtons?.pushing(false);
                if (res == null) {
                    return;
                }

                this.costTypes.reset(res);
                PJQ.notifications.notify.successNotify({
                    message: 'Cost Types successfully pushed to ERP'
                });
                this.render();
            });
        }
    },
    pullERP: function () {
        if (this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COST_TYPES)) {
            this.erpButtons?.pulling(true);
            this.erpIntegration.pullCostTypes((res, err) => {
                this.erpButtons?.pulling(false);
                if (res == null) {
                    return;
                }

                this.costTypes.reset(res);
                PJQ.notifications.notify.successNotify({
                    message: _.size(res).toString() + ' Cost Types pulled from ERP'
                });
                if (typeof this.options.onPullERP === 'function') {
                    this.options.onPullERP();
                } else {
                    this.render();
                }
            });
        }
    },
    addClicked: function () {
        this.editCostType(null);
    },
    editClicked: function (e) {
        let id = $(e.currentTarget).closest('tr').attr('id');
        if (_.size(id) > 0) {
            let costType = this.costTypes.get(id);
            if (costType != null) {
                this.editCostType(costType);
            }
        }
    },
    editCostType: function (costType) {
        new PJQ.views.budget.EditCostTypeModal({
            model: costType,
            project: this.options.project,
            onSave: _.bind(function (costType) {
                this.costTypes.add(costType);
                if (this.options.project) {
                    this.options.project.costTypes.add(costType);
                }
                this.render();
            }, this),
            onDelete: _.bind(function (costType) {
                if (costType.id > 0) {
                    this.deleteCostType(costType, false);
                }
            }, this)
        });
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('tr').attr('id'),
            costCode = this.costTypes.get(cid);
        this.deleteCostType(costCode);
    },
    deleteAll: function () {
        let ct = _.size(this.costTypes.models);
        if (ct === 0) {
            return;
        }

        let msg = 'Are you sure you want to delete all <strong>' + ct + '</strong> Company Cost Types?';
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: msg,
            onDelete: _.bind(function () {

            }, this)
        });
    },
    deleteCostType: function (costType, showDialogue = true) {
        if (showDialogue) {
            new PJQ.views.modals.DeleteCancel({
                header: "Confirm Deletion",
                body: "Are you sure you want to delete this Cost Type?",
                onDelete: _.bind(function () {
                    costType.destroy({
                        notify: false,
                        success: _.bind(function () {
                            this.costTypes.remove(costType);
                            this.render();
                        }, this),
                        error: function (model, xhr) {
                            if (xhr.responseJSON != null && xhr.responseJSON.type === 'delete_type_with_line_item') {
                                PJQ.notifications.notify.warningNotify({
                                    message: 'This cost type cannot be deleted because it is being used on budget line items.'
                                });
                            }
                        }
                    });
                }, this)
            });
        } else {
            costType.destroy({
                notify: false,
                success: _.bind(function () {
                    this.costTypes.remove(costType);
                    this.render();
                }, this)
            });
        }
    }
});

PJQ.views.budget.EditCostTypeModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-edit-cost-type'),
        maxWidth: 600
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-close': 'close',
        'click .btn-delete': 'delete'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        if (this.model == null) {
            this.model = new PJQ.models.budget.CostType();
        }

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        this.costTypes = await PJQ.app.session.fetchCostTypes();

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            costTypes: this.costTypes,
            erpIntegration: this.erpIntegration,
            externalObject: this.model.get('externalObject'),
            isFetched: this.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input',
                'select'
            ]
        });

        this.$(".input-name").inputmask({
            "mask": "a".repeat(50),
            placeholder: "",
            definitions: {
                'a': {
                    validator: ".",
                    cardinality: 1
                }
            }
        });

        this.$(".input-code").inputmask({
            "mask": "a".repeat(20),
            placeholder: "",
            definitions: {
                'a': {
                    validator: "[0-9a-zA-Z]",
                    cardinality: 1
                }
            }
        });

        if (this.erpIntegration != null) {
            this.renderIntegrationFields();
        }
    },
    renderIntegrationFields: function () {
        if (this.erpIntegration == null) {
            return;
        }

        switch (this.erpIntegration.get('name')) {
            case PJQ.constants.integrations.providers.ACUMATICA.name:
                let defaultNonStockItem = this.erpIntegration.getSetting('defaultNonStockItem'),
                    externalObj = this.model.get('externalObject');

                let nonStockItem = defaultNonStockItem;
                if (externalObj != null && externalObj.data?.nonStockItem != null) {
                    nonStockItem = externalObj.data?.nonStockItem;
                }

                new PJQ.inputs.SelectPickerEditorInput({
                    el: this.$('.edit-non-stock'),
                    isFormInput: true,
                    editButtonText: "Change",
                    label: 'Non-Stock Item',
                    title: 'The Non-Stock Item used when syncing Commitments to Acumatica Subcontract and Purchase Order lines which use this cost type',
                    showSaveButton: false,
                    defaultDisplayValue: nonStockItem != null ? nonStockItem.inventoryID : null,
                    value: nonStockItem != null ? nonStockItem.id : null,
                    getChoices: (cb) => {
                        let fnCallback = () => {
                            cb(_.map(this.erpIntegration.settingsData.nonStockItems, function (item) {
                                return {
                                    id: item.id,
                                    name: item.inventoryID
                                };
                            }));
                        };
                        if (this.erpIntegration.settingsData?.nonStockItems != null) {
                            fnCallback();
                            return;
                        }

                        this.erpIntegration.fetchSettingsData((data) => {
                            fnCallback();
                        }, {
                            type: 'non_stock_items'
                        });
                    },
                    onChange: (value) => {
                        let item = this.erpIntegration.settingsData.nonStockItems.find((item) => item.id === value);
                        if (item != null) {
                            this.erpIntegration.setSetting('nonStockItem', item);
                        }

                        let exObj = this.model.get('externalObject');
                        if (defaultNonStockItem?.id === item.id) {
                            delete exObj.data.nonStockItem;
                        } else {
                            exObj.data.nonStockItem = item;
                        }
                        exObj.isDirty = true;
                        this.model.set('externalObject', exObj);
                    }
                });
                break;
        }
    },
    close: function () {
        if (this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    if (this.options.onClose) {
                        this.options.onClose(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else if (this.options.onClose) {
            this.options.onClose(this.model);
            this.removeModal();
        }
    },
    validate: function () {
        let isValid = true;

        let $name = this.$('.input-name');
        PJQ.helpers.inputHelpers.setInputError($name, true);
        if (this.model.get('name') == null || this.model.get('name').length === 0) {
            PJQ.helpers.inputHelpers.setInputError($name, false);
            isValid = false;
        }

        let $code = this.$('.input-code');
        PJQ.helpers.inputHelpers.setInputError($code, true);
        if (this.model.get('code') == null || this.model.get('code').length === 0) {
            PJQ.helpers.inputHelpers.setInputError($code, false);
            isValid = false;
        }

        return isValid;
    },
    save: function () {
        if (!this.validate()) {
            return;
        }

        let fnSaveERPObj = (cb) => {
            let exObj = this.model.get('externalObject');
            if (this.erpIntegration == null || exObj == null || !exObj.isDirty) {
                cb();
                return;
            }

            this.erpIntegration.updateCostTypeData(exObj, (res, err) => {
                cb();
            });
        }

        fnSaveERPObj(() => {
            this.model.save(null, {
                success: () => {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    this.costTypes.add(this.model);

                    this.removeModal();
                    PJQ.notifications.notify.successNotify({
                        message: 'Cost Type saved'
                    });
                }
            });
        });
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this Cost Type?",
            onDelete: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});